import React from 'react';
import { Table } from 'antd';
import { formatDateTime } from '@utils/helpers/formatDate';

const columns = [
  {
    title: 'No',
    dataIndex: 'no',
    key: 'no'
  },
  {
    title: 'Seller Name',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'Product Name',
    dataIndex: 'productName',
    key: 'productName'
  },
  {
    title: 'SKU',
    dataIndex: 'sku',
    key: 'sku'
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    key: 'quantity'
  },
  {
    title: 'Return / Disposal',
    dataIndex: 'processType',
    key: 'processType',
    render: (value: string) => {
      return value?.charAt(0)?.toUpperCase() + value?.slice(1);
    }
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status'
  },
  {
    title: 'Update Date',
    render: (record: any) => {
      return formatDateTime(record.updatedAt);
    }
  }
];

interface IProps {
  loading: boolean;
  getData: Function;
  totalItems: number;
  returnProductRowData: any;
  selectedReturnProduct: React.Key[];
  setSelectedReturnProduct: React.Dispatch<React.SetStateAction<React.Key[]>>;
  onChangePage: (page: number) => void;
}

const ReturnProductListTable = ({
  loading,
  totalItems,
  returnProductRowData,
  selectedReturnProduct,
  onChangePage,
  setSelectedReturnProduct
}: IProps) => {
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedReturnProduct(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedReturnProduct,
    onChange: onSelectChange
  };

  return (
    <div>
      <Table
        className="busk-table"
        rowSelection={rowSelection}
        loading={loading}
        columns={columns}
        dataSource={returnProductRowData}
        pagination={{
          pageSize: 10,
          total: totalItems,
          onChange: onChangePage
        }}
      />
    </div>
  );
};

export default ReturnProductListTable;
